import * as React from 'react';

export const Answer = (props) => {

    const onCheckAnswer = () => {

        props.onSelectAnswer( props.idx,props.data.correct );
        props.onAnswerQuestion();
    }

    if ( ! props.isCurrentquestion || ( props.checkAnswer && props.isCurrentquestion) ) {
        return (
            <div className="answer">
                <input type="radio" name={props.question_idx} disabled={true} onClick={onCheckAnswer} />

                { props.data.correct && props.gaveThisAnswer ? <span className="answered correct">{props.data.title}</span> :  props.gaveThisAnswer ? <span className="answered incorrect">{props.data.title}</span> :  props.data.correct ? <span className="correct">{props.data.title}</span> : <span>{props.data.title}</span>}

            </div>
        );
    }

    let classes = ["answer"];
    if(props.gaveThisAnswer) classes.push("check");

    return (
        <div className={classes.join(" ")}>
            <input type="radio" defaultChecked={props.gaveThisAnswer} id={props.idx} name={props.question_idx} onChange={onCheckAnswer} />
            <label onClick={onCheckAnswer} htmlFor={props.idx}>{props.data.title}</label>
        </div>
    );

}
